import React from 'react';

const SelectField = ({ field, onInputChange }) => {
    const { label, cssClass, placeholder, isRequired, value, choices } = field;
    return (
        <div className={`form-field ${cssClass}`}>
            <select
                name={label.toLowerCase()}
                aria-label={placeholder}
                onChange={onInputChange}
                value={value ? value : ''}
            >
                <option>{placeholder}</option>
                {choices?.map((choice, index) => (
                    <option key={'choice-' + index} value={choice.value}>
                        {choice.text}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default SelectField;